import { Directive,HostBinding, HostListener,Output, EventEmitter} from '@angular/core';

@Directive({
  selector: '[appDraggable]'
})
export class DraggableDirective {
  
  @HostBinding('class.draggable') draggable = true; 

  @HostBinding('class.dragging') dragging = false;

  @Output() dragStart= new EventEmitter<PointerEvent>();
  @Output() dragMove= new EventEmitter<PointerEvent>();
  @Output() dragEnd= new EventEmitter<PointerEvent>();

  @HostListener('pointerdown',['$event']) onpointerdown(event:PointerEvent): void{
    this.dragging=true;
    event.stopPropagation();
    this.dragStart.emit(event);
  }

  @HostListener('document:pointermove',['$event']) onpointermove(event:PointerEvent):void{
    if(!this.dragging)
      return;
    this.dragMove.emit(event);
  }

   @HostListener('document:pointerup',['$event']) onpointerup(event:PointerEvent):void{
    if(!this.dragging)
      return;
    this.dragEnd.emit(event);
    this.dragging=false;
  }
}